/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} General_Delete_Relations_Blocked_PrefixInputs */

const en_general_delete_relations_blocked_prefix = /** @type {(inputs: General_Delete_Relations_Blocked_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The item cannot be deleted. Please delete the relations first: `)
};

const de_general_delete_relations_blocked_prefix = /** @type {(inputs: General_Delete_Relations_Blocked_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eintrag kann nicht gelöscht werden. Bitte löschen Sie zuerst die Zuordnungen: `)
};

/**
* | output |
* | --- |
* | "The item cannot be deleted. Please delete the relations first:" |
*
* @param {General_Delete_Relations_Blocked_PrefixInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const general_delete_relations_blocked_prefix = /** @type {((inputs?: General_Delete_Relations_Blocked_PrefixInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<General_Delete_Relations_Blocked_PrefixInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_general_delete_relations_blocked_prefix(inputs)
	return de_general_delete_relations_blocked_prefix(inputs)
});